import {EventEmitter} from "@shop/frontend/web/js/components/EventEmitter";
import api from "@shop/frontend/web/js/api";
import {translator} from "@shop/frontend/web/js/services/TranslatorService";
import {CartModel} from "@shop/frontend/web/js/models/CartModel";
import {Modal} from "@shop/frontend/web/js/components/Modal";
import {CartView} from "../views/CartView";
import {utils} from "../../../../../shop/frontend/web/js/utils";

class CartController {
	constructor() {
		this.emitter = new EventEmitter();

		this.model = new CartModel();
		this.view = new CartView();

		this.fastRegisterModal = null;
		this.collectivePurchaseModal = null;

		this.currentOrderId = null;
		this.currentEventId = null;
	}

	init() {
		this.setUpSubscribers();
		this.setUpListeners();

		translator.getLanguages().then(() => {
			this.initPromoCode();
		});

		if ($(".price-category-select").length > 0) this.initPriceLoyaltyCategories();
		if ($(".js-ticket-required-param-btn").length > 0) this.initTicketRequiredParam();
		if ($("[data-acquiring-id]").length > 0) this.initAcquirings();
		this.modal = new Modal();
		if ($("#fastRegisterModal").length) {
			this.fastRegisterModal = new Modal();
			this.fastRegisterModal.use("fastRegisterModal");
			this.initFastRegistration();
		}

		// Модалка для формирования коллективной покупки
		if ($('#collective-purchase-modal').length) {
			this.collectivePurchaseModal = new Modal();
			this.collectivePurchaseModal.use('collective-purchase-modal');
		}

		/* Проверяет необходимо ли идентифицировать пользователя */
		if ($("[data-need-check-fan=true]").length > 0) this.initCheckFanId();
		this.setDiscount();
	}

	setUpSubscribers() {
		/** @event CartController#event:remove-ticket */
		this.emitter.subscribe("event:remove-ticket", ({sid, eventId, uid}) => {
			api.eventCart
				.removeFromCart({eventId, sid, uid})
				.then(res => {
					if (res.error) throw new Error(res.msg);
					if (!res.carts) return false;

					const orderData = this.model.validateOrder(res);

					window.CartService.count = window.CartService.count - 1;
					window.CartService.updateCount();

					this.view.removeOrderTickets(res.order_id, res.carts);
					this.view.renderOrder(orderData);

					this.emitter.emit("event:update-acquirings", {orderId: orderData.id});
				})
				.catch(err => {
					console.log(err);

					this.modal.show(
						`
						${translator.t("main", "An error occurred when deleting from the basket!")}
						<p>${err.message}</p>
						`
					);

					this.modal.on("hide", () => window.location.reload());
				});
		});

		/** @event CartController#event:remove-event */
		this.emitter.subscribe("event:remove-event", ({eventId, orderId}) => {
			api.eventCart
				.removeEventFromOrder({eventId, orderId})
				.then(res => {
					if (res.error) throw new Error(res.msg);
					if (res.refresh) return window.location.reload();
					if (!res.success) throw new Error("unknown");

					//TODO: пока так т.к. не получаем полный заказ как при удалении билета (или придумать что то)
					return window.location.reload();
				})
				.catch(err => {
					console.log(err);
					this.modal.show(
						`
						${translator.t("main", "An error occurred when deleting from the basket!")}
						<p>${err.message}</p>
						`
					);

					this.modal.on("hide", () => window.location.reload());
				});
		});

		/** @event CartController#event:cancel-order */
		this.emitter.subscribe("event:cancel-order", orderId => {
			api.order
				.cancel({orderId})
				.then(res => {
					if (res.error) throw new Error(res.msg);

					//TODO: пока так т.к. не получаем полный заказ как при удалении билета (или придумать что то)
					return window.location.reload();
				})
				.catch(err => {
					console.log(err);
					this.modal.show(
						`
						${translator.t("main", "An error occurred when deleting from the basket!")}
						<p>${err.message}</p>
						`
					);

					this.modal.on("hide", () => window.location.reload());
				});
		});

		this.emitter.subscribe("event:remove-sub-event", ({eventId, subEventId}) => {
			api.subscription
				.removeEventSids({eventId, subEventId})
				.then(res => {
					if (!res.result) throw new Error(result.msg);

					const orderId = this.view.getOrderIdBySubEventId(subEventId);

					this.view.removeSubEvent(subEventId);

					const count = this.view.updateSubscriptionCount(orderId);
					if (!count > 0) return window.location.reload();

					this.view.renderOrderDiscount(orderId, 0);
					this.view.showSumLoader(orderId);

					api.eventCart.getCart({eventId}).then(res => {
						const orderSum = {};

						if (res.length > 0) {
							$.each(res, (i, order) => {
								if (order.id === orderId) {
									orderSum.sum = order.amount + order.commission;
									orderSum.defaultSum = order.default_amount;
								}
							});
						}

						this.view.renderOrderDiscount(orderId, orderSum.defaultSum - orderSum.sum);
						this.view.updateOrderSum(orderId, orderSum.sum);
					});
				})
				.catch(err => {
					console.log(err);
					this.modal.show(
						`
						${translator.t("main", "An error occurred when deleting from the basket!")}
						<p>${err.message}</p>
						`
					);

					this.modal.on("hide", () => window.location.reload());
				});
		});

		/** @event CartController#event:clear-cart */
		this.emitter.subscribe("event:clear-cart", () => {
			api.order
				.cancelAll()
				.then(res => {
					if (!res.result) throw new Error(res.message);

					//TODO: можно просто показать что корзина пуста
					return window.location.reload();
				})
				.catch(err => {
					console.log(err);
					this.modal.show(
						`
						${translator.t("main", "An error occurred when deleting from the basket!")}
					<p>${err.message}</p>
						`
					);

					this.modal.on("hide", () => window.location.reload());
				});
		});
	}

	setUpListeners() {
		$(document).on("click", ".js-tickets-remove", e => {
			const sid = $(e.currentTarget).parents(".ticket-item").attr("data-place");
			const eventId = $(e.currentTarget).parents(".ticket-item").attr("data-event");
			const uid = $(e.currentTarget).parents(".ticket-item").attr("data-uid");

			this.emitter.emit("event:remove-ticket", {sid, eventId, uid});
		});

		$(document).on("click", ".js-order-revert", e => {
			const eventId = $(e.currentTarget).attr("data-event");
			const orderId = $(e.currentTarget).attr("data-order");

			this.emitter.emit("event:remove-event", {eventId, orderId});
		});

		$(document).on("click", ".js-order-cancel", e =>
			this.emitter.emit("event:cancel-order", $(e.currentTarget).attr("data-order"))
		);

		$(document).on("click", "#js-order-clear", e => this.emitter.emit("event:clear-cart"));

		$(document).on("click", ".js-booking-delete", e => {
			const eventId = $(e.currentTarget).parents(".js-booking").data("event-id");
			const subEventId = $(e.currentTarget).parents(".js-booking").data("sub-event-id");

			return this.emitter.emit("event:remove-sub-event", {eventId, subEventId});
		});

		$(".js-bookings-open").on("click", e => {
			const element = $(e.currentTarget);

			element.toggleClass("active");
			return element.parents(".bookings").find(".js-bookings-wrapper").slideToggle();
		});

		$(".js-tickets-service-remove").on("click", e => {
			const uid = $(e.currentTarget).data("uid");
			const service_id = $(e.currentTarget).data("service");

			//todo: переделать без обновления страницы
			api.service.removeTicket({service_id, uid}).then(res => window.location.reload());
		});

		$(".js-order-service-delete").on("click", e => {
			const $tickets = $(e.currentTarget).parents(".js-order").find(".tickets");

			$.each($tickets, (index, elem) => {
				const count = $(elem).data("count");
				const serviceId = $(elem).data("service");
				api.service.removeService({serviceId, count}).then(res => {
					if (!res.carts.length) {
						//todo: переделать без обновления страницы
						window.location.reload();
					}
				});
			});
		});

		$(document).on('click', '.js-collective-buy', (e) => {
			const $currentTarget = $(e.currentTarget);

			if ($currentTarget.hasClass('order__collective-button_disabled')) {
				return;
			}

			const $orderItem = $currentTarget.parents('.order__item');

			this.currentOrderId = $currentTarget.parents('.js-order').attr('data-id');
			this.currentEventId = $orderItem.find('.js-order-event').attr('data-event-id');

			this.collectivePurchaseModal.show();
		});

		$('.js-make-order-collective').on('click', async () => {
			try {
				await api.bulkBuyTeacher.makeOrderBulk(this.currentOrderId, this.currentEventId);
				$(location).prop('href', `${window.location.origin}/collective-purchase`);
			} catch (e) {
				console.log(e);
				this.collectivePurchaseModal.hide();
				this.modal.show(JSON.parse(e).error);
				this.modal.on('hide', () => window.location.reload());
			}
		});
	}

	initFastRegistration() {
		const getType = (jsOrderEl) => {
			if (jsOrderEl.find(".js-order-event").data("event-id") !== undefined) {
				return 'event';
			}
			if (jsOrderEl.find(".js-order-service").data("service") !== undefined) {
				return 'service';
			}

			return 'Unknown type';
		};

		$(document).on("click", ".js-get-fast-registration", e => {
			e.preventDefault();
			const el = $(e.currentTarget);
			const jsOrderEl = el.parents(".js-order");
			const sum = jsOrderEl.find(".js-sum").text();
			const type = getType(jsOrderEl);
			this.fastRegisterModal.show();
			let actionPath = $("#fast-registration-controller").attr("action");
			$(".js-sum-fast").text(sum);

			const buildActionPath = (type, className, dataAttr) => {
				const dataId = jsOrderEl.find(className).data(dataAttr);
				const [pathname, queryString] = actionPath.split('?');
				const params = new URLSearchParams(queryString);

				params.set('event_id', dataId);
				params.set('type', type);
				actionPath = [pathname, params.toString()].join('?');
			};

			switch (type) {
				case 'event':
					buildActionPath(type, '.js-order-event', 'event-id');
					break;
				case 'service':
					buildActionPath(type, '.js-order-service', 'service');
					break;
				default:
					throw new Error(`${type}`);
			}

			$("#fast-registration-controller").attr("action", actionPath);
		});
	}

	initCheckFanId() {
		let orderId = 0;
		let redirectUrl = "";
		let userEmail = "";
		let userPhone = "";
		const fanIdModal = new Modal();
		fanIdModal.use("fan_id_modal");

		const renderEventsNamesByOrderId = orderId => {
			const eventsNames = [];
			$.each(this.view.getOrderEvents(orderId), (index, $event) => {
				const nameList = $($event).find(".teams__name");

				if (nameList.length > 1) {
					eventsNames.push(
						`«${$(nameList[0]).text().trim()} — ${$(nameList[1]).text().trim()}»`
					);
				}
			});
			$("#js-fan-id-events").text(eventsNames.join(", "));
		};

		/* обработчик быстрой регистрации на ajax */
		$("#fast-registration-controller").on("submit", e => {
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();

			let data = new FormData(e.target);
			let url = $(e.target).attr("action");
			userEmail = $("input[name='FastRegistrationForm[email]']").val();
			userPhone = $("input[name='FastRegistrationForm[phone]']").val();

			/* Использует fetch для обохода проверки isAjax(XMLHttpRequest) на yii2 */
			fetch(url, {
				method: "POST",
				body: data,
			})
				.then(response => response.json())
				.then(data => {
					redirectUrl = data.redirectUrl;
					this.fastRegisterModal.hide();

					renderEventsNamesByOrderId(orderId);
					fanIdModal.show();
					$("input#phone_number_value").val(userPhone || "");
					$("input#email_number_value").val(userEmail || "");

					$(".order__button").removeClass("js-get-fast-registration");
				});
		});

		/* Инициализация формы fan id */
		const fanIdForm = $("#js-fan-id-form");
		const inputs = $(".js-fan-id-input input");

		fanIdForm.on("submit", () => {
			const type = $("#js-fan-id-form input[type=radio]:checked").val();
			const value = $(`#${type}_number_value`).val();
			$("#js-fan-id-error").text("");

			api.orders
				.checkFan(orderId, type, value)
				.then(res => {
					if (res && res.result === false) throw new Error();

					const payUrl = $(`.js-order[data-id=${orderId}]`)
						.find(".order__button")
						.attr("href");
					return redirectUrl
						? (window.location.href = redirectUrl)
						: payUrl
						? (window.location.href = payUrl)
						: window.location.reload();
				})
				.catch((error = {}) => {
					$("#js-fan-id-error").text(error.error || "Не удалось идентифицировать");
				});

			return false;
		});

		$("#js-fan-id-form input[type=radio]").on("change", e => {
			const type = $(e.currentTarget).val();
			inputs.removeAttr("required").parent().addClass("d-none");
			$(`#input_${type}_number`).removeClass("d-none").children().prop("required", true);
			checkSelectedRequiredInput();
		});
		$("#js-fan-id-form .i-text-input__input").on("keyup change", () => {
			checkSelectedRequiredInput();
		});

		/* дизейблит кнопку если инпут пустой */
		function checkSelectedRequiredInput() {
			const selectedType = $("#js-fan-id-form input[type=radio]:checked").val();
			const selectedValue = $(`#${selectedType}_number_value`).val();
			if (selectedValue === "") {
				$("#js-fan-id-form button[type=submit]").prop("disabled", true);
			} else {
				$("#js-fan-id-form button[type=submit]").prop("disabled", false);
			}
		}
		checkSelectedRequiredInput();

		$(".order__button").on("click", e => {
			const $elem = $(e.currentTarget);
			orderId = $(e.currentTarget).parents(".js-order").data("id");
			if ($elem.hasClass("js-get-fast-registration")) return true;
			if ($elem.attr("data-toggle") === "modal") {
				this.fastRegisterModal.show();
				return;
			}

			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();

			renderEventsNamesByOrderId(orderId);

			fanIdModal.show();
		});
	}

	initPromoCode() {
		this.emitter.subscribe("event:apply-promo", ({code, orderId}) => {
			if (!code.trim()) return false;
			api.promo
				.apply({orderId, code: code.trim()})
				.then(res => {
					if (!res.status) throw new Error(res.msg);

					const $promo = $(`.js-promo[data-order=${orderId}]`);

					$promo
						.find(".promo__button")
						.addClass("active")
						.text(translator.t("main", "Applied"));
					$promo.find(".promo__message").text("");
					$promo.find(".promo__input").val(code).attr("disabled", true);
					$promo.removeClass("active");

					const orderData = this.model.validateOrder({
						...res,
						order_id: res.order_id ? res.order_id : orderId,
					});

					this.view.renderOrder(orderData);
					this.view.updateOrderSum(orderId, res.summ - res.commission);
				})
				.catch(err => {
					console.log(err);
					$(`.js-promo[data-order=${orderId}]`)
						.find(".promo__message")
						.addClass("error")
						.text(err.message || translator.t("main", "An error occurred!"));
				});
		});

		$.each($(".js-promo"), (i, element) => {
			const promoInput = $(element).find(".promo__input");
			const promoMessage = $(element).find(".promo__message");
			promoInput.on("keypress", () => {
				promoMessage.text("");
				if (promoInput.val().trim()) $(element).addClass("active");
			});

			promoInput.on("input", () => {
				promoMessage.text("");
				if (promoInput.val().trim()) $(element).addClass("active");
			});

			promoInput.on("focus", () => {
				$(element).addClass("focus");
			});

			promoInput.on("blur", () => {
				$(element).removeClass("active").removeClass("focus");

				if (promoInput.val().trim()) {
					$(element).addClass("active").removeClass("focus");
				}
			});
		});

		$(document).on("keydown", ".js-promo .promo__input", e => {
			const orderId = $(e.target).parents(".js-promo").data("order");
			const code = $(e.target).val();

			if (e.which === 13 || e.keyCode === 13 || e.key === "Enter")
				return this.emitter.emit("event:apply-promo", {code, orderId});
		});

		$(document).on("click", ".js-promo .promo__button", e => {
			const orderId = $(e.target).parents(".js-promo").data("order");
			const code = $(e.target).parents(".js-promo").find(".promo__input").val();

			return this.emitter.emit("event:apply-promo", {code, orderId});
		});
	}

	initAcquirings() {
		$.each($("[data-acquiring-id]"), (i, $acquiring) => {
			if (!$($acquiring).attr("href")) return true;

			$($acquiring).on("click", e => {
				e.preventDefault();
				const acquiringId = $($acquiring).attr("data-acquiring-id");
				const orderId = $($acquiring).parents(".js-order").attr("data-id");

				api.pay
					.changePayAcquiring({orderId, acquiringId})
					.then(res => {
						if (!res.result && document.location.pathname.match(/cart/))
							throw new Error(res.message || "");
						if ($($acquiring).hasClass("js-get-fast-registration")) return true;

						return (window.location.href = $($acquiring).attr("href"));
					})
					.catch(err => {
						if ($($acquiring).hasClass("js-get-fast-registration"))
							this.fastRegisterModal.hide();

						this.modal.show(
							`
									${translator.t("main", "An error occurred when deleting from the basket!")}
									<p>${err.message}</p>
								`
						);

						this.modal.on("hide", () => window.location.reload());
						console.log(err);
					});
			});
		});

		this.emitter.subscribe("event:update-acquirings", ({orderId}) => {
			api.order.getAcquirings({orderId}).then(res => {
				$.each(res, (i, acquiringData) => {
					const isDisabled = acquiringData.disabled;
					const acquiring = acquiringData.acquiring;
					const $acquiring = $(`.js-order[data-id=${orderId}]`).find(
						`[data-acquiring-id=${acquiring.id}]`
					);

					if (isDisabled) {
						if (!$acquiring.hasClass("inactive")) $acquiring.addClass("inactive");
					} else {
						if ($acquiring.hasClass("inactive")) $acquiring.removeClass("inactive");
					}
				});
			});
		});
	}

	initTicketRequiredParam() {
		$(document).on("click", ".js-ticket-required-param-btn", e => {
			const $btn = $(e.currentTarget);
			this.modal.show(
				`
					<p>${$($btn).attr("data-extra-info-question")}</p>
					<div class="form-group">
						<input type="text" class="enter__input js-without-symbols js-max-value" max="255" value="${$(
							$btn
						).attr("data-extra-info")}" placeholder="Введите ваши данные">
					</div>
          <button class="btn btn_wide" id="js-ticket-required-param" data-uid="${$($btn).attr(
				"data-uid"
			)}" data-bs-dismiss="modal">Далее</button>
				`,
				{className: "i-modal_alert"}
			);

			//дизейблить кнопку если нет данных в инпуте
			const $input = $("#js-ticket-required-param").parent().find("input[type=text]");
			if (!$($input).val()) $("#js-ticket-required-param").addClass("inactive");
			$($input).on("keyup change", () => {
				if ($($input).val()) return $("#js-ticket-required-param").removeClass("inactive");
				return $("#js-ticket-required-param").addClass("inactive");
			});
		});

		$(document).on("click", "#js-ticket-required-param", e => {
			const uid = $(e.currentTarget).attr("data-uid");
			const text = $(e.currentTarget).parent().find("input[type=text]").val();
			api.eventCart
				.saveExtraInfo({uid, text})
				.then(res => {
					if (res.error) throw new Error(res.msg);

					if (res.success) {
						updateRequiredParamBtn(uid, text);
					}
				})
				.catch(err => {
					console.log(err);
					this.modal.show(
						`
						${translator.t("main", "An error occurred!")}
						<p>${err.message}</p>
						`
					);
				});
		});

		$(".order__button").on("click", e => {
			if (!checkIsRequiredParamsValid()) {
				e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();
				this.modal.show(
					`
						<p>Заполните обязательные поля под каждым билетом</p>
         			 <button class="btn btn_wide" data-bs-dismiss="modal">Закрыть</button>
					`,
					{className: "i-modal_alert"}
				);
				return false;
			}
		});

		function updateRequiredParamBtn(uid, text) {
			const $oldBtn = $(`.js-ticket-required-param-btn[data-uid=${uid}]`);
			const ticketItem = $oldBtn.parents(".ticket-item");
			ticketItem.addClass("max-width");

			const template = `
				<div class="d-inline-flex align-self-start mt-2">
			    <strong class="text-uppercase mr-2 adding-params">${text}</strong>
			    <button class="reset-btn text-success js-ticket-required-param-btn"
			            data-extra-info="${text}"
			            data-extra-info-question="${$oldBtn.attr("data-extra-info-question")}"
			            data-uid="${uid}"
			    >
			      Изменить
			    </button>
			  </div>
			`;

			if ($oldBtn.hasClass("text-success")) {
				$oldBtn.parent().after(template);
				$oldBtn.parent().remove();
			} else {
				$oldBtn.after(template);
				$oldBtn.remove();
			}
		}

		function checkIsRequiredParamsValid() {
			let isValid = true;
			$.each($(".js-ticket-required-param-btn"), (i, $btn) => {
				if (!$($btn).attr("data-extra-info")) {
					isValid = false;
					return false;
				}
			});
			return isValid;
		}
	}

	setDiscount() {
		$(".js-promo").each((index, item) => {
			$(item)
				.parents(".js-order")
				.find(".js-ticket-price")
				.each((index, item) => {
					$(item).text($(item).data("price"));
				});
		});
	}

	initPriceLoyaltyCategories() {
		$(".price-category-select input").on("change", e => {
			const $input = $(e.currentTarget);
			const orderId = $input.parents(".js-order").attr("data-id");
			const eventId = $input.parents(".js-order-event").attr("data-event-id");
			const uid = $input.parents(".ticket-item").attr("data-uid");
			const priceId = $input.val();
			const categoryId = $input.attr("data-category-id");
			const promoText = $input.parents(".js-order").find(".promo__input")[0].value.trim();
			const token = $("head")?.find("meta[name='csrf-token']")[0]?.content;

			function setActiveItem(id, name) {
				$input.parents(".price-category-select").attr("data-item-id", id);
				$input
					.parents(".price-category-select")
					.find(".price-category-select__selected-name").html(`
						<svg class="icon" width="20" height="20">
			        <use xlink:href="#${id === "0" ? "ticket-category" : "user-child"}"></use>
			      </svg>
			      <span>${name}</span>
					`);
			}

			function cancelSelect() {
				$.each($(".price-category-select input"), (i, elem) => {
					const currentId = $(elem)
						.parents(".price-category-select")
						.attr("data-item-id");
					if ($(elem).attr("data-category-id") === currentId) {
						$(elem).prop("checked", true);
					}
				});
			}

			api.eventCart
				.changePriceId({eventId, orderId, uid, priceId, categoryId})
				.then(res => {
					if (res.error) throw new Error(res.msg || "");

					setActiveItem(categoryId, $input.attr("data-name"));

					$(".js-promo").each((index, item) => {
						if ($(item).find(".promo__button").hasClass("active")) {
							api.promo.cancel({orderId, code: promoText}).then(res => {
								api.promo.apply({orderId, code: promoText}).then(res => {
									const orderData = this.model.validateOrder({
										...res,
										order_id: orderId,
									});

									this.view.renderOrder(orderData);
								});
							});
						} else {
							const orderData = this.model.validateOrder(res);
							this.view.renderOrder(orderData);
						}
					});
				})
				.catch(err => {
					console.log(err);
					if (err.message && err.message === "Требуется хотя бы один взрослый билет!") {
						this.modal.show(`${err.message}`);
						cancelSelect();
						return false;
					}
					this.modal.show(
						`
						${translator.t("main", "An error occurred!")}
						<p>${err.message}</p>
						`
					);

					this.modal.on("hide", () => window.location.reload());
				});
		});
	}
}

const cartController = new CartController();
cartController.init();
import { createApp } from "vue";
import Cart from "../../vue/views/cart/CartView.vue";

const cartApp = createApp(Cart);
cartApp.mount("#root-cart-view");
